var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import RepairabilityIndexUtility from '../../utilities/RepairabilityIndexUtility.js';
import RepairabilityIndexCardStyle from './RepairabilityIndexCardStyle.js';
export default class RepairabilityIndexCard extends KompisElement {
    render() {
        return html `
			<style>
				${RepairabilityIndexCardStyle.getStyle()}
			</style>

			${this.getRepairabilityIndexDocument()}
		`;
    }
    getRepairabilityIndexDocument() {
        // The PDF version is lower file size, but using PDF requires an iframe (or some other solution) which is why the image file formats are used instead.
        const documentUrl = RepairabilityIndexUtility.getDocumentUrl(this.product, 'svg') ??
            RepairabilityIndexUtility.getDocumentUrl(this.product, 'png');
        if (!documentUrl) {
            return null;
        }
        return html `<img
			src="${documentUrl}"
			alt="${RepairabilityIndexUtility.getImageAltText(this.product)}"
		/>`;
    }
}
__decorate([
    property({ type: Object, required: true })
], RepairabilityIndexCard.prototype, "product", void 0);
//# sourceMappingURL=RepairabilityIndexCard.js.map